// extracted by mini-css-extract-plugin
module.exports = {"content":"Bundle_content__khx2h","image":"Bundle_image__Udjva"};